<template>
    <div class="white-box white-box-no-tab">
        <!-- 集中檢核 -->
        <PopupCheckBDP
            v-model:postApiCheckBDP="postApiCheckBDP"
            @confirm="confirmApiCheckBDP"
            @close="isLoading = false"
        />
        <!-- 門號核實 -->
        <ModalMobileVerify
            v-model:postApiMid="postApiMid"
            @confirm="confirmApiMid"
        />
        <h3 class="mb-2.5">
            {{ title }}
        </h3>
        <p class="text-base xs:text-lg text-gray-900 pb-4 border-b mb-3.5">
            即日起線上保單服務皆會發送動態密碼予您，並驗證您輸入的動態密碼正確後，才完成線上保單服務申請。
        </p>
        <EditTelAndMailInput
            v-model:validInput="validInput"
            v-model:isDisable="isDisable"
            :info="info"
            :mobileCodeList="mobileCodeList"
            :catchErrorArray="catchErrorArray"
            @getValidResult="getValidResult"
            @closePopup="closePopup"
            @clearError="catchErrorArray = []"
        />
        <div class="text-center">
            <button
                class="btn rounded-full"
                :class="[isDisable?'btn-accent':'gradient-primary']"
                :disabled="isDisable"
                @click="validInput = true"
            >
                確定
            </button>
        </div>
        <Loading :is-loading="isLoading" />
        <PopupEffect v-model:visiblePopup="visiblePopup" />
    </div>
</template>

<script>
import { computed, reactive, ref, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getMobileCodeInfoPon4300, submitContactPon4300 } from '@/apis/Pon4300';
import { getContactInfo, startTransaction, submitContact } from '@/apis/system';
import { getNeedMIDVerify } from '@/apis/mid';
import Loading from '@/components/Loading.vue';
import PopupEffect from '@/components/dialogs/PopupEffect.vue';
import PopupCheckBDP from '@/components/dialogs/PopupCheckBDP.vue';
import ModalMobileVerify from '@/components/dialogs/ModalMobileVerify/ModalMobileVerify.vue';
import aplCatlCode from '@/json/aplCatlCode';
import EditTelAndMailInput from './InputForm.vue';
import routeName from '@/router/constant.js';

export default {
    components: {
        Loading,
        PopupCheckBDP,
        ModalMobileVerify,
        EditTelAndMailInput,
        PopupEffect
    },
    setup() {
        const store = useStore();
        const mobileCodeList = ref([]);
        const router = useRouter();
        const postApiCheckBDP = ref(false);
        const visiblePopup = ref(false);
        const postApiMid = ref(false);
        const serviceList = computed(() => store.state.services.serviceList);
        const aplCatl = computed(() => store.state.services.aplCatl);
        const isPon4300 = computed(() => aplCatl.value === aplCatlCode.PON4300);
        const title = computed(() => {
            if (isPon4300.value) {
                return '保險單借款';
            } else {
                return serviceList.value[0] ? serviceList.value[0].transactionItemName : '';
            }
        });

        const state = reactive({
            isLoading: false,
            validInput: false,
            isDisable: false,
        });

        const data = reactive({
            info: {},
            returnObj: {},
            mobileCodeList: [],
            catchErrorArray: []
        });

        const getData = async () => {
            if (aplCatl.value === aplCatlCode.MULTI_ENOTIFY) {
                visiblePopup.value = true;
            }
            state.isLoading = true;
            await getContactInfo().then(res => {
                if (res.data) {
                    data.info.mobileCountry = res.data.mobileCountry;
                    data.info.mobile = res.data.mobile;
                    data.info.email = res.data.email;
                }
            }).catch((error) => {
                data.catchErrorArray = [error.data];
                state.isLoading = false;
            });

            getMobileCodeInfoPon4300().then(res => {
                state.isLoading = false;
                if (res.data) {
                    mobileCodeList.value = res.data.mobileCodeList.map(i => {
                        i.label = `${i.text}(+${i.value})`;
                        return i;
                    });
                }
            }).catch(() => {
                state.isLoading = false;
            });
        };
        getData();

        const getValidResult = (returnObj) => {
            if (returnObj.isPass) {
                goNext(returnObj.returnData);
            }
        };

        const goNext = (returnData) => {
            state.isLoading = true;
            const FN = isPon4300.value ? submitContactPon4300 : submitContact;

            FN(returnData).then(res => {
                postApiCheckBDP.value = true;
            }).catch(error => {
                state.isLoading = false;
                data.catchErrorArray = error.data.details;
            });
        };

        const confirmApiCheckBDP = () => {
            state.isLoading = false;
            getNeedMIDVerify().then(res => {
                if (res.data.flag) {
                    postApiMid.value = true;
                } else {
                    startTransaction().then(() => {
                        router.push({ name: serviceList.value[0].routeName });
                    });
                }
            });
        };

        const confirmApiMid = () => {
            startTransaction().then(() => {
                router.push({ name: serviceList.value[0].routeName });
            });
        };

        const closePopup = () => {
            router.push({ name: routeName.HOME });
        };

        return {
            ...toRefs(state),
            ...toRefs(data),
            postApiCheckBDP,
            postApiMid,
            mobileCodeList,
            title,
            visiblePopup,
            confirmApiMid,
            confirmApiCheckBDP,
            getValidResult,
            closePopup,
            goNext,
        };
    },
};
</script>
